<template>
  <v-dialog
    v-model="dialog"
    max-width="70vw"
    scrollable
    :retain-focus="false"
    persistent
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-stepper v-model="e6" vertical outlined non-linear flat>
          <v-stepper-step :complete="e6 > 1" step="1">
            A. PROVIDERS
          </v-stepper-step>
          <v-stepper-content step="1">
            <v-card class="pa-3 " outlined>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Name"
                    v-model="item.providersName"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    label="Location"
                    v-model="item.location"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    label="Case #"
                    v-model="item.caseNo"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field label="Age" v-model="item.age"></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-select
                    :items="gender"
                    label="Gender"
                    v-model="item.gender"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    label="Date Submiited"
                    v-model="item.dateSubmitted"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    label="Date of Incident"
                    v-model="item.incidentDate"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    label="Time of Accident (Start)"
                    v-model="item.incidentTimeStart"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    label="ime of Accident (End)"
                    v-model="item.incidentTimeEnd"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="1">
                  <v-checkbox label="DRC " v-model="item.isDRC"></v-checkbox>
                </v-col>
                <v-col cols="12" md="1">
                  <v-checkbox label="RRC " v-model="item.isRRC"></v-checkbox>
                </v-col>
                <v-col cols="12" md="1">
                  <v-checkbox label="SRC" v-model="item.isSRC"></v-checkbox>
                </v-col>
              </v-row>
              <v-row justify="end" class="mb-2 mr-2">
                <v-btn color="primary" @click="e6 = 2">
                  Continue
                </v-btn>
              </v-row>
            </v-card>
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 2" step="2">
            B. DESCRIBE THE INCIDENT
            <small>
              (ONLY refer by case # do NOT use person's name or initials)</small
            >
          </v-stepper-step>
          <v-stepper-content step="2">
            <v-card class="pa-3 " outlined>
              <v-row>
                <v-col cols="12" md="12">
                  <v-textarea
                    auto-grow
                    outlined
                    label="Describe the incident"
                    v-model="item.describeIncident"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row justify="end" class="mb-2 mr-2">
                <v-btn color="primary" @click="e6 = 3">
                  Continue
                </v-btn>
              </v-row>
            </v-card>
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 3" step="3">
            C. METHODS USED TO AVOID RESTRAINT
            <small>(Check all that applies)</small>
          </v-stepper-step>

          <v-stepper-content step="3">
            <v-card class="pa-3 " outlined>
              <v-row>
                <v-col cols="12" md="3">
                  <v-checkbox
                    label="Verbal redirection"
                    v-model="item.isVerbalRedirection"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="3">
                  <v-checkbox
                    label="Changing staff"
                    v-model="item.isChangingStuff"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="3">
                  <v-checkbox
                    label="Counseling"
                    v-model="item.isCounseling"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="3">
                  <v-checkbox
                    label="No time to avoid"
                    v-model="item.isAvoid"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row class="mt-n5">
                <v-col cols="12" md="3">
                  <v-checkbox
                    label="One to one Supervision"
                    v-model="item.isSupervision"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="3">
                  <v-checkbox
                    label="Changing activity"
                    v-model="item.isChangingActivity"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="3">
                  <v-checkbox
                    label="Adapting environmen"
                    v-model="item.isAdaptingEnvironment"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="3">
                  <v-checkbox
                    label="Calming techniques/DBT"
                    v-model="item.isCalmingTechnique"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row class="mt-n5">
                <v-col cols="12" md="3">
                  <v-checkbox
                    label="Other(s)"
                    v-model="item.isOther"
                    @change="item.otherSpecify = ''"
                  ></v-checkbox>
                </v-col>

                <v-col cols="12" md="12" class="mt-n5">
                  <v-expand-transition>
                    <v-textarea
                      v-if="item.isOther"
                      auto-grow
                      outlined
                      label="Describe"
                      v-model="item.otherSpecify"
                    ></v-textarea>
                  </v-expand-transition>
                </v-col>
              </v-row>
              <v-row justify="end" class="mb-2 mr-2">
                <v-btn color="primary" @click="e6 = 4">
                  Continue
                </v-btn>
              </v-row>
            </v-card>
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 4" step="4">
            D. REASON RESTRAINT WAS IMPLEMENTED
          </v-stepper-step>
          <v-stepper-content step="4">
            <v-card class="pa-3 " outlined>
              <v-row>
                <v-col cols="12" md="12">
                  <v-checkbox
                    label="Emergency (check all that apply)"
                    v-model="item.isEmergency"
                    @change="
                      (item.isAggression = false) ||
                        (item.isHarmful = false) ||
                        (item.isProperty = false)
                    "
                  ></v-checkbox>
                  <v-row class="mx-4">
                    <v-expand-transition>
                      <v-col v-if="item.isEmergency" class="pa-0">
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-checkbox
                              label="Aggression or negative impact towards other"
                              v-model="item.isAggression"
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-checkbox
                              label="Harmful to self "
                              v-model="item.isHarmful"
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-checkbox
                              label="Property destruction"
                              v-model="item.isProperty"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-expand-transition>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="mt-n5">
                <v-col cols="12" md="3">
                  <v-checkbox
                    label="Medical Treatment"
                    v-model="item.isRestrainMedicalTreatment"
                    @change="item.describeRestrainMedicalTreatment = ''"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" md="12" class="mt-n5">
                  <v-expand-transition>
                    <v-textarea
                      v-if="item.isRestrainMedicalTreatment"
                      auto-grow
                      outlined
                      label="Describe"
                      v-model="item.describeRestrainMedicalTreatment"
                    ></v-textarea>
                  </v-expand-transition>
                </v-col>
              </v-row>
              <v-row justify="end" class="mb-2 mr-2">
                <v-btn color="primary" @click="e6 = 5">
                  Continue
                </v-btn>
              </v-row>
            </v-card>
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 5" step="5">
            E. TYPE OF RESTRAINT USED (check all that applies search restraint
            and total time)
          </v-stepper-step>
          <v-stepper-content step="5">
            <v-card class="pa-3 " outlined>
              <v-row>
                <v-col cols="12" md="12">
                  <v-checkbox
                      label="1. PHYSICAL"
                      v-model="item.isPhysical"
                    ></v-checkbox>
                  <v-row class="mx-4">
                    <v-col v-if="item.isPhysical" class="pa-0">
                      <v-row>
                        <v-col cols="12" md="2">
                          <small></small>
                        </v-col>
                        <v-col cols="12" md="2">
                          <small>TOTAL</small>
                        </v-col>
                        <v-col cols="12" md="2">
                          <small>TOTAL</small>
                        </v-col>
                        <v-col cols="12" md="2">
                          <small>TOTAL</small>
                        </v-col>
                      </v-row>
                      <v-divider />
                      <v-row
                        v-for="(physicalType, index) in item.physicalTypeOfRestraint"
                        :key="index"
                      >
                        <v-expand-transition>
                          <v-col cols="12" md="12">
                            <v-row class="staff-restrain-row">
                              <v-col cols="12" md="2">
                                <v-text-field
                                  label=""
                                  v-model="physicalType.name"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" md="2">
                                <v-text-field
                                  label="TOTAL"
                                  v-model="physicalType.total1"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" md="2">
                                <v-text-field
                                  label="TOTAL"
                                  v-model="physicalType.total2"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" md="2">
                                <v-text-field
                                  label="TOTAL"
                                  v-model="physicalType.total3"
                                ></v-text-field>
                              </v-col>
                              <v-fab-transition>
                                <v-btn
                                  v-if="item.physicalTypeOfRestraint.length > 1"
                                  color="red"
                                  class="mt-11 ml-n16 self-restrain-fab"
                                  dark
                                  absolute
                                  top
                                  right
                                  fab
                                  x-small
                                  max-height="25"
                                  max-width="25"
                                  @click="onRemovePhysicalTypeRestraint(index)"
                                >
                                  <v-icon>mdi-close</v-icon>
                                </v-btn>
                              </v-fab-transition>
                            </v-row>
                          </v-col>
                         </v-expand-transition>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-row align="center" justify="start" class="mt-n5" v-if="item.isPhysical">
                  <v-card-actions>
                    <v-btn
                      v-if="item.physicalTypeOfRestraint.length < 10"
                      color="primary"
                      @click="onAddPhysicalTypeRestraint"
                      >Add</v-btn
                    >
                    <v-btn
                      v-if="item.physicalTypeOfRestraint.length <= 1"
                      outlined
                      color="primary"
                      @click="resetPhysicalRestraint"
                      >Reset</v-btn
                    >
                  </v-card-actions>
                </v-row>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <v-checkbox
                      label="2. MECHANICAL"
                      v-model="item.isMechanical"
                    ></v-checkbox>
                  <v-row class="mx-4">
                    <v-col v-if="item.isMechanical" class="pa-0">
                      <v-row>
                        <v-col cols="12" md="2">
                          <small></small>
                        </v-col>
                        <v-col cols="12" md="2">
                          <small>TOTAL</small>
                        </v-col>
                        <v-col cols="12" md="2">
                          <small>TOTAL</small>
                        </v-col>
                        <v-col cols="12" md="2">
                          <small>TOTAL</small>
                        </v-col>
                      </v-row>
                      <v-divider />
                      <v-row
                        v-for="(mechanicalType, index) in item.mechanicalTypeOfRestraint"
                        :key="index"
                      >
                        <v-expand-transition>
                          <v-col cols="12" md="12">
                            <v-row class="staff-restrain-row">
                              <v-col cols="12" md="2">
                                <v-text-field
                                  label=""
                                  v-model="mechanicalType.name"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" md="2">
                                <v-text-field
                                  label="TOTAL"
                                  v-model="mechanicalType.total1"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" md="2">
                                <v-text-field
                                  label="TOTAL"
                                  v-model="mechanicalType.total2"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" md="2">
                                <v-text-field
                                  label="TOTAL"
                                  v-model="mechanicalType.total3"
                                ></v-text-field>
                              </v-col>
                              <v-fab-transition>
                                <v-btn
                                  v-if="item.mechanicalTypeOfRestraint.length > 1"
                                  color="red"
                                  class="mt-11 ml-n16 self-restrain-fab"
                                  dark
                                  absolute
                                  top
                                  right
                                  fab
                                  x-small
                                  max-height="25"
                                  max-width="25"
                                  @click="onRemoveMechanicalTypeRestraint(index)"
                                >
                                  <v-icon>mdi-close</v-icon>
                                </v-btn>
                              </v-fab-transition>
                            </v-row>
                          </v-col>
                         </v-expand-transition>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-row align="center" justify="start" class="mt-n5" v-if="item.isMechanical">
                  <v-card-actions>
                    <v-btn
                      v-if="item.mechanicalTypeOfRestraint.length < 10"
                      color="primary"
                      @click="onAddMechanicalTypeRestraint"
                      >Add</v-btn
                    >
                    <v-btn
                      v-if="item.mechanicalTypeOfRestraint.length <= 1"
                      outlined
                      color="primary"
                      @click="resetMechanicalRestraint"
                      >Reset</v-btn
                    >
                  </v-card-actions>
                </v-row>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <v-checkbox
                      label="3. Chemical"
                      v-model="item.isChemical"
                    ></v-checkbox>
                  <v-row class="mx-4">
                    <v-col v-if="item.isChemical" class="pa-0">
                      <v-row>
                        <v-col cols="12" md="2">
                          <small></small>
                        </v-col>
                        <v-col cols="12" md="2">
                          <small>TOTAL</small>
                        </v-col>
                        <v-col cols="12" md="2">
                          <small>TOTAL</small>
                        </v-col>
                        <v-col cols="12" md="2">
                          <small>TOTAL</small>
                        </v-col>
                      </v-row>
                      <v-divider />
                      <v-row
                        v-for="(chemicalType, index) in item.chemicalTypeOfRestraint"
                        :key="index"
                      >
                        <v-expand-transition>
                          <v-col cols="12" md="12">
                            <v-row class="staff-restrain-row">
                              <v-col cols="12" md="2">
                                <v-text-field
                                  label=""
                                  v-model="chemicalType.name"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" md="2">
                                <v-text-field
                                  label="TOTAL"
                                  v-model="chemicalType.total1"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" md="2">
                                <v-text-field
                                  label="TOTAL"
                                  v-model="chemicalType.total2"
                                ></v-text-field>
                              </v-col>
                              <v-col cols="12" md="2">
                                <v-text-field
                                  label="TOTAL"
                                  v-model="chemicalType.total3"
                                ></v-text-field>
                              </v-col>
                              <v-fab-transition>
                                <v-btn
                                  v-if="item.chemicalTypeOfRestraint.length > 1"
                                  color="red"
                                  class="mt-11 ml-n16 self-restrain-fab"
                                  dark
                                  absolute
                                  top
                                  right
                                  fab
                                  x-small
                                  max-height="25"
                                  max-width="25"
                                  @click="onRemoveChemicalTypeRestraint(index)"
                                >
                                  <v-icon>mdi-close</v-icon>
                                </v-btn>
                              </v-fab-transition>
                            </v-row>
                          </v-col>
                         </v-expand-transition>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-row align="center" justify="start" class="mt-n5" v-if="item.isChemical">
                  <v-card-actions>
                    <v-btn
                      v-if="item.chemicalTypeOfRestraint.length < 10"
                      color="primary"
                      @click="onAddChemicalTypeRestraint"
                      >Add</v-btn
                    >
                    <v-btn
                      v-if="item.chemicalTypeOfRestraint.length <= 1"
                      outlined
                      color="primary"
                      @click="resetChemicalRestraint"
                      >Reset</v-btn
                    >
                  </v-card-actions>
                </v-row>
              </v-row>
              <v-row justify="end" class="mb-2 mr-2">
                <v-btn color="primary" @click="e6 = 6">
                  Continue
                </v-btn>
              </v-row>
            </v-card>
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 6" step="6">
            F. Are there any team directed limitations or modifications to the
            use of restraint?
          </v-stepper-step>
          <v-stepper-content step="6">
            <v-card class="pa-3 " outlined>
              <v-row>
                <v-col cols="12" md="12">
                  <v-radio-group
                    row
                    v-model="item.isLimitation"
                    @change="item.describeLimitation = ''"
                  >
                    <v-col cols="12" md="1" class="pa-0">
                      <v-radio label="No" :value="false"></v-radio>
                    </v-col>
                    <v-col cols="12" md="1" class="pa-0">
                      <v-radio label="Yes " :value="true"></v-radio>
                    </v-col>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" md="12" class="mt-n5">
                  <v-expand-transition>
                    <v-textarea
                      v-if="item.isLimitation"
                      auto-grow
                      outlined
                      label="Describe"
                      v-model="item.describeLimitation"
                    ></v-textarea>
                  </v-expand-transition>
                </v-col>
              </v-row>
              <v-row justify="end" class="mb-2 mr-2">
                <v-btn color="primary" @click="e6 = 7">
                  Continue
                </v-btn>
              </v-row>
            </v-card>
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 7" step="7">
            G. STAFF DIRECTLY INVOLVED IN RESTRAINT
          </v-stepper-step>
          <v-stepper-content step="7">
            <v-card class="pa-3 " outlined>
              <v-row>
                <v-col cols="12" md="2">
                  <small>NAME</small>
                </v-col>
                <v-col cols="12" md="2">
                  <small>TITLE</small>
                </v-col>
                <v-col cols="12" md="2">
                  <small>AGENCY</small>
                </v-col>
                <v-col cols="12" md="2">
                  <small>Currently certified in crisis intervention?</small>
                </v-col>
                <v-col cols="12" md="2">
                  <small
                    >TYPE(i.e. CPART, CPM, CPI, Safety Care, MANDT, SOAR)
                  </small>
                </v-col>
              </v-row>

              <v-divider />

              <v-row
                v-for="(staffInvolved, index) in item.staffInvolvedRestraint"
                :key="index"
              >
                <v-expand-transition>
                  <v-col cols="12" md="12">
                    <v-row class="staff-restrain-row">
                      <v-col cols="12" md="2">
                        <v-text-field
                          label="Name"
                          v-model="staffInvolved.name"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-text-field
                          label="Title"
                          v-model="staffInvolved.title"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-text-field
                          label="Agency"
                          v-model="staffInvolved.agency"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-row justify="center">
                          <v-radio-group
                            row
                            v-model="staffInvolved.isCertified"
                          >
                            <v-col cols="12" md="6">
                              <v-radio label="No" :value="false"></v-radio>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-radio label="Yes " :value="true"></v-radio>
                            </v-col>
                          </v-radio-group>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-text-field
                          label="Type"
                          v-model="staffInvolved.restrainType"
                        ></v-text-field>
                      </v-col>
                      <v-fab-transition>
                        <v-btn
                          v-if="item.staffInvolvedRestraint.length > 1"
                          color="red"
                          class="mt-11 ml-n16 self-restrain-fab"
                          dark
                          absolute
                          top
                          right
                          fab
                          x-small
                          max-height="25"
                          max-width="25"
                          @click="onRemoveStaffRestrainItem(index)"
                        >
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-fab-transition>
                    </v-row>
                  </v-col>
                </v-expand-transition>
              </v-row>

              <v-row align="center" justify="start" class="mt-n5">
                <v-card-actions>
                  <v-btn
                    v-if="item.staffInvolvedRestraint.length < 10"
                    color="primary"
                    @click="onAddStaffRestrainItem"
                    >Add</v-btn
                  >
                  <v-btn
                    v-if="item.staffInvolvedRestraint.length <= 1"
                    outlined
                    color="primary"
                    @click="reset"
                    >Reset</v-btn
                  >
                </v-card-actions>
              </v-row>
              <v-row justify="end" class="mb-2 mr-2 ">
                <v-btn color="primary" @click="e6 = 8">
                  Continue
                </v-btn>
              </v-row>
            </v-card>
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 8" step="8">
            H. Behavioral Support plan(s) in place?
          </v-stepper-step>
          <v-stepper-content step="8">
            <v-card class="pa-3 " outlined>
              <v-row>
                <v-col cols="12" md="2">
                  <v-row>
                    <v-radio-group row v-model="item.isBehavioralSupport">
                      <v-col cols="12" md="6">
                        <v-radio label="No" :value="false"></v-radio>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-radio label="Yes " :value="true"></v-radio>
                      </v-col>
                    </v-radio-group>
                  </v-row>
                </v-col>
              </v-row>

              <v-row justify="end" class="mb-2 mr-2">
                <v-btn color="primary" @click="e6 = 9">
                  Continue
                </v-btn>
              </v-row>
            </v-card>
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 9" step="9">
            I. Is use of restraint part of approved treatment support plan
          </v-stepper-step>
          <v-stepper-content step="9">
            <v-card class="pa-3 " outlined>
              <v-row>
                <v-col cols="12" md="12">
                  <v-radio-group
                    row
                    v-model="item.isSupportPlan"
                    @change="item.indicateSupportPlan = ''"
                  >
                    <v-col cols="12" md="1" class="pa-0">
                      <v-radio label="No" :value="false"></v-radio>
                    </v-col>
                    <v-col cols="12" md="11" class="pa-0">
                      <v-radio
                        label="Yes (please indicate when plan was approved)"
                        :value="true"
                      ></v-radio>
                    </v-col>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" md="12" class="mt-n5">
                  <v-expand-transition>
                    <v-textarea
                      v-if="item.isSupportPlan"
                      auto-grow
                      outlined
                      v-model="item.indicateSupportPlan"
                    ></v-textarea>
                  </v-expand-transition>
                </v-col>
              </v-row>

              <v-row justify="end" class="mb-2 mr-2">
                <v-btn color="primary" @click="e6 = 10">
                  Continue
                </v-btn>
              </v-row>
            </v-card>
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 10" step="10">
            J. Were there any injuries to the person?
          </v-stepper-step>
          <v-stepper-content step="10">
            <v-card class="pa-3 " outlined>
              <v-row>
                <v-col cols="12" md="12">
                  <v-radio-group
                    row
                    v-model="item.isInjuriesPerson"
                    @change="
                      (item.isDueRestraint = false) ||
                        (item.isDueSelfHarm = false)
                    "
                  >
                    <v-col cols="12" md="1" class="pa-0">
                      <v-radio label="No" :value="false"></v-radio>
                    </v-col>
                    <v-col cols="12" md="11" class="pa-0">
                      <v-radio
                        label="(if Yes choose any that applies below and explain how it happen)"
                        :value="true"
                      ></v-radio>
                    </v-col>
                  </v-radio-group>
                </v-col>

                <v-expand-transition>
                  <v-col
                    cols="12"
                    md="12"
                    class="mt-n5"
                    v-if="item.isInjuriesPerson"
                  >
                    <v-row class="mx-5">
                      <v-col cols="12" md="12">
                        <v-checkbox
                          label="Due to restraint?"
                          v-model="item.isDueRestraint"
                          @change="item.describeRestrain = ''"
                        ></v-checkbox>
                        <v-expand-transition>
                          <v-textarea
                            v-if="item.isDueRestraint"
                            auto-grow
                            outlined
                            v-model="item.describeRestraint"
                          ></v-textarea>
                        </v-expand-transition>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-checkbox
                          label="Due to self-harm or accident, peer aggression etc.?"
                          v-model="item.isDueSelfHarm"
                          @change="item.describeSelfHarm = ''"
                        ></v-checkbox>
                        <v-expand-transition>
                          <v-textarea
                            v-if="item.isDueSelfHarm"
                            auto-grow
                            outlined
                            v-model="item.describeSelfHarm"
                          ></v-textarea>
                        </v-expand-transition>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-expand-transition>
              </v-row>

              <v-row justify="end" class="mb-2 mr-2">
                <v-btn color="primary" @click="e6 = 11">
                  Continue
                </v-btn>
              </v-row>
            </v-card>
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 11" step="11">
            K. Were there any injuries to the Staff?
          </v-stepper-step>
          <v-stepper-content step="11">
            <v-card class="pa-3 " outlined>
              <v-row>
                <v-col cols="12" md="6">
                  <v-radio-group
                    row
                    v-model="item.isInjuriesStaff"
                    @change="
                      (item.isRestraint = false) || (item.isAccidental = false)
                    "
                  >
                    <v-col cols="12" md="2" class="pa-0">
                      <v-radio label="No" :value="false"></v-radio>
                    </v-col>
                    <v-col cols="12" md="10" class="pa-0">
                      <v-radio
                        label="Yes (If Yes please indicate if it was from/during)"
                        :value="true"
                      ></v-radio>
                    </v-col>
                  </v-radio-group>
                </v-col>
                <v-expand-transition>
                  <v-col cols="12" md="6" v-if="item.isInjuriesStaff">
                    <v-row>
                      <v-col cols="12" md="3">
                        <v-checkbox
                          label="restraint "
                          v-model="item.isRestraint"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12" md="9">
                        <v-checkbox
                          label="incident or accidental, person aggression, etc"
                          v-model="item.isAccidental"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-expand-transition>
              </v-row>
              <v-row justify="end" class="mb-2 mr-2">
                <v-btn color="primary" @click="e6 = 12">
                  Continue
                </v-btn>
              </v-row>
            </v-card>
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 12" step="12">
            L. STAFF COMPLETING SECTIONS A-K
          </v-stepper-step>
          <v-stepper-content step="12">
            <v-card class="pa-3 " outlined>
              <v-row>
                <v-col cols="12" md="3">
                  <v-text-field
                    label="Name"
                    v-model="item.staffCompletingSectionAK.name"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    label="Title"
                    v-model="item.staffCompletingSectionAK.title"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    label="Signature"
                    v-model="item.staffCompletingSectionAK.signature"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    label="Date"
                    v-model="item.staffCompletingSectionAK.date"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="end" class="mb-2 mr-2">
                <v-btn color="primary" @click="e6 = 13">
                  Continue
                </v-btn>
              </v-row>
            </v-card>
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 13" step="13">
            M. Was a Nurse or Physician contacted during or following the use of
            restraint?
          </v-stepper-step>
          <v-stepper-content step="13">
            <v-card class="pa-3 " outlined>
              <v-row>
                <v-col cols="12" md="6">
                  <v-radio-group
                    row
                    v-model="item.isNursePhysicianContacted"
                    @change="item.nursePhysicianName = ''"
                  >
                    <v-col cols="12" md="2" class="pa-0">
                      <v-radio label="No" :value="false"></v-radio>
                    </v-col>
                    <v-col cols="12" md="10" class="pa-0">
                      <v-radio
                        label="Yes (Print Physician/Nurse name)"
                        :value="true"
                      ></v-radio>
                    </v-col>
                  </v-radio-group>
                </v-col>
                <v-expand-transition>
                  <v-col cols="12" md="6" v-if="item.isNursePhysicianContacted">
                    <v-text-field
                      label="Print Physician/Nurse name "
                      v-model="item.nursePhysicianName"
                    ></v-text-field>
                  </v-col>
                </v-expand-transition>
              </v-row>
              <v-row justify="end" class="mb-2 mr-2">
                <v-btn color="primary" @click="e6 = 14">
                  Continue
                </v-btn>
              </v-row>
            </v-card>
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 14" step="14">
            N. Was there any medical treatment?
          </v-stepper-step>
          <v-stepper-content step="14">
            <v-card class="pa-3 " outlined>
              <v-row>
                <v-col cols="12" md="12">
                  <v-radio-group
                    row
                    v-model="item.isMedicalTreatment"
                    @change="item.describeMedicalTreatment = ''"
                  >
                    <v-col cols="12" md="1" class="pa-0">
                      <v-radio label="No" :value="false"></v-radio>
                    </v-col>
                    <v-col cols="12" md="1" class="pa-0">
                      <v-radio label="Yes " :value="true"></v-radio>
                    </v-col>
                  </v-radio-group>
                </v-col>
                <v-col cols="12" md="12" class="mt-n5">
                  <v-expand-transition>
                    <v-textarea
                      v-if="item.isMedicalTreatment"
                      auto-grow
                      outlined
                      label="Describe"
                      v-model="item.describeMedicalTreatment"
                    ></v-textarea>
                  </v-expand-transition>
                </v-col>
              </v-row>
              <v-row justify="end" class="mb-2 mr-2">
                <v-btn color="primary" @click="e6 = 15">
                  Continue
                </v-btn>
              </v-row>
            </v-card>
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 15" step="15">
            O. STAFF COMPLETING SECTIONS M-N
          </v-stepper-step>
          <v-stepper-content step="15">
            <v-card class="pa-3 " outlined>
              <v-row>
                <v-col cols="12" md="3">
                  <v-text-field
                    label="Name"
                    v-model="item.staffCompletingSectionMN.name"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    label="Title"
                    v-model="item.staffCompletingSectionMN.title"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    label="Signature"
                    v-model="item.staffCompletingSectionMN.signature"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-text-field
                    label="Date"
                    v-model="item.staffCompletingSectionMN.date"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row justify="end" class="mb-2 mr-2">
                <v-btn color="primary" @click="e6 = 1">
                  Continue
                </v-btn>
              </v-row>
            </v-card>
          </v-stepper-content>
        </v-stepper>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">
          Close
        </v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click="newItem ? onAddItem() : onUpdateItem(item._id)"
        >
          {{ newItem ? "Save" : "Update" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      gender: ["Male", "Female"],
      // clientID: localStorage.getItem("clientId"),
      newItem: true,
      e6: 1,
      item: {
        //A
        providersName: "",
        location: "",
        caseNo: "",
        age: "",
        gender: "",
        dateSubmitted: "",
        incidentDate: "",
        incidentTimeStart: "",
        incidentTimeEnd: "",
        isDRC: false,
        isRRC: false,
        isSRC: false,

        //B
        describeIncident: "",

        //C
        isVerbalRedirection: false,
        isSupervision: false,
        isChangingStuff: false,
        isChangingActivity: false,
        isCounseling: false,
        isAdaptingEnvironment: false,
        isAvoid: false,
        isCalmingTechnique: false,
        isOther: false,
        otherSpecify: "",

        //D
        isEmergency: false,
        isAggression: false,
        isHarmful: false,
        isProperty: false,
        isRestrainMedicalTreatment: false,
        describeRestrainMedicalTreatment: "",

        //E
        isPhysical: false,
        isChemical: false,
        isMechanical: false,
        physicalTypeOfRestraint : [{}],
        mechanicalTypeOfRestraint : [{}],
        chemicalTypeOfRestraint : [{}],

        //F
        isLimitation: null,
        describeLimitation: "",

        //G
        staffInvolvedRestraint: [{}],

        //H
        isBehavioralSupport: null,
        isSupportPlan: null,
        indicateSupportPlan: "",

        //J
        isInjuriesPerson: null,
        isDueRestraint: false,
        isDueSelfHarm: false,
        describeRestraint: "",
        describeSelfHarm: "",

        //K
        isInjuriesStaff: null,
        isRestraint: false,
        isAccidental: false,

        //L
        staffCompletingSectionAK: {
          name: "",
          title: "",
          signature: "",
          date: "",
        },

        //M
        isNursePhysicianContacted: null,
        nursePhysicianName: "",

        //N
        isMedicalTreatment: null,
        describeMedicalTreatment: "",

        //O
        staffCompletingSectionMN: {
          name: "",
          title: "",
          signature: "",
          date: "",
        },
      },
      defaultItem: {
        //A
        providersName: "",
        location: "",
        caseNo: "",
        age: "",
        gender: "",
        dateSubmitted: "",
        incidentDate: "",
        incidentTimeStart: "",
        incidentTimeEnd: "",
        isDRC: false,
        isRRC: false,
        isSRC: false,

        //B
        describeIncident: "",

        //C
        isVerbalRedirection: false,
        isSupervision: false,
        isChangingStuff: false,
        isChangingActivity: false,
        isCounseling: false,
        isAdaptingEnvironment: false,
        isAvoid: false,
        isCalmingTechnique: false,
        isOther: false,
        otherSpecify: "",

        //D
        isEmergency: false,
        isAggression: false,
        isHarmful: false,
        isProperty: false,
        isRestrainMedicalTreatment: false,
        describeRestrainMedicalTreatment: "",

        //E
        isPhysical: false,
        isChemical: false,
        isMechanical: false,
        physicalTypeOfRestraint : [{}],
        mechanicalTypeOfRestraint : [{}],
        chemicalTypeOfRestraint : [{}],

        //F
        isLimitation: null,
        describeLimitation: "",

        //G
        staffInvolvedRestraint: [{}],

        //H
        isBehavioralSupport: null,
        isSupportPlan: null,
        indicateSupportPlan: "",

        //J
        isInjuriesPerson: null,
        isDueRestraint: false,
        isDueSelfHarm: false,
        describeRestraint: "",
        describeSelfHarm: "",

        //K
        isInjuriesStaff: null,
        isRestraint: false,
        isAccidental: false,

        //L
        staffCompletingSectionAK: {
          name: "",
          title: "",
          signature: "",
          date: "",
        },

        //M
        isNursePhysicianContacted: null,
        nursePhysicianName: "",

        //N
        isMedicalTreatment: null,
        describeMedicalTreatment: "",

        //O
        staffCompletingSectionMN: {
          name: "",
          title: "",
          signature: "",
          date: "",
        },
      },
    };
  },
  computed: {
    dialog: {
      get() {
        return this.$store.state.rad.dialog;
      },
      set(val) {
        this.$store.commit("rad/SET_DIALOG", val);
      },
    },
    formTitle() {
      return this.newItem ? "New RAD" : "Edit RAD";
    },
    clientID(){
      return this.$store.state.clients.client._id
    },
  },
  methods: {
    ...mapActions("rad", ["addRAD", "updateRAD"]),

    onAddStaffRestrainItem() {
      this.item.staffInvolvedRestraint.push({});
    },

    onAddPhysicalTypeRestraint() {
      this.item.physicalTypeOfRestraint.push({});
    },

    onAddMechanicalTypeRestraint() {
      this.item.mechanicalTypeOfRestraint.push({});
    },

    onAddChemicalTypeRestraint() {
      this.item.chemicalTypeOfRestraint.push({});
    },

    onRemoveStaffRestrainItem(index) {
      this.item.staffInvolvedRestraint.splice(index, 1);
    },

    onRemovePhysicalTypeRestraint(index) {
      this.item.physicalTypeOfRestraint.splice(index, 1);
    },

    onRemoveMechanicalTypeRestraint(index) {
      this.item.mechanicalTypeOfRestraint.splice(index, 1);
    },

    onRemoveChemicalTypeRestraint(index) {
      this.item.chemicalTypeOfRestraint.splice(index, 1);
    },

    onViewItem(item) {
      this.newItem = false;
      this.item = Object.assign({}, item);
      this.dialog = true;
    },
    async onAddItem() {
      console.log({
          ...this.item,
          clientID: this.clientID,
        });
      try {
        this.newItem = true;
        const response = await this.addRAD({
          ...this.item,
          clientID: this.clientID,
        });

        if (response.success) {
          this.close();
        }
      } catch (error) {
        console.log(error);
      }
    },

    async onUpdateItem(id) {
      try {
        const response = await this.updateRAD({
          data: this.item,
          id,
        });

        if (response.success) {
          this.close();
        }
      } catch (error) {
        console.log(error);
      }
    },

    reset() {
      this.item.staffInvolvedRestraint = [
        {
          name: "",
          title: "",
          agency: "",
          isCertified: null,
          restrainType: "",
        },
      ];
    },

    resetPhysicalRestraint() {
      this.item.physicalTypeOfRestraint = [
        {
          name: "",
          total1: "",
          total2: "",
          total3: "",
        },
      ];
    },

    resetMechanicalRestraint() {
      this.item.physicalTypeOfRestraint = [
        {
          name: "",
          total1: "",
          total2: "",
          total3: "",
        },
      ];
    },

    resetChemicalRestraint() {
      this.item.physicalTypeOfRestraint = [
        {
          name: "",
          total1: "",
          total2: "",
          total3: "",
        },
      ];
    },

    close() {
      this.dialog = false;
      this.newItem = true;
      this.$nextTick(() => {
        this.item = Object.assign({}, this.defaultItem);
      });
    },
  },
};
</script>

<style scoped>
.v-stepper {
  box-shadow: none !important;
}

.staff-restrain-row {
  position: relative;
}

.self-restrain-fab {
  position: absolute;
}
</style>
